module.exports = __webpack_public_path__ + "2be40230.png";